module.exports = __webpack_public_path__ + "img/14.f6f52d7e.jpg";